export enum APPLICATION_ROUTES {
    // PRIVATE app routes
    CONTENT = "/app/content",
    PORTFOLIO_APP = "/app/portfolio",
    COLLECTIONS = "/app/collections",
    COLLECTION = "/app/collection",
    COLLECTION_SORT = "/app/collection/[collectionId]/sort",
    NEWSLETTER = "/app/newsletter",
    NEWSLETTER_SUBSCRIBERS = "/app/newsletter/subscribers",
    NEWSLETTER_REPORT = "/app/newsletter/report",
    NEWSLETTER_SETTINGS = "/app/newsletter/settings",
    ANALYTICS = "/app/analytics",
    ANALYTICS_WEB = "/app/analytics/web",
    ANALYTICS_SMART_SHARE = "/app/settings/smart-share-links",
    SETTINGS_SMART_SHARE_LINK = "/app/settings/smart-share-links/[linkId]",
    SETTINGS_ACCOUNT = "/app/settings/account",
    SETTINGS_BILLING = "/app/settings/billing",
    SETTINGS_REFERRAL = "/app/settings/referral",
    SETTINGS_SOURCES = "/app/settings/sources",
    SETTINGS_CUSTOM_DOMAINS = "/app/settings/custom-domain",
    SETTINGS_WEBHOOKS = "/app/settings/webhooks",
    SETTINGS_NOTIFICATIONS = "/app/settings/notifications",
    SETTINGS_CERTIFICATES = "/app/settings/certificates",
    SETTINGS_PLUGIN = "/app/settings/plugin",
    SETTINGS_AI_INTEGRATION = "/app/settings/ai-integration",
    WRITE = "/app/write",
    ACCOUNTS = "/app/accounts",
    UPDATE_PAYMENT = "/payment/update",

    // PUBLIC PAGES
    AUTHOR_PAGE = "/[author]",
    AUTHOR_PAGE_SECRET_LINK = "/[author]/po/[profileAccessKey]",
    ABOUT_PAGE = "/[author]/p/[aboutPageSlug]",
    PROFILE_COLLECTION_PAGE = "/[author]/c/[collectionAccessKey]",
    PROFILE_CONTENT_ITEM_PAGE = "/[author]/a/[contentItemAccessKey]",
    COLLECTION_PAGE = "/[author]/co/[collectionAccessKey]",
    COLLECTION_CONTENT_ITEM_PAGE = "/[author]/co/[collectionAccessKey]/a/[contentItemAccessKey]",
    CONTENT_ITEM_PAGE = "/[author]/ci/[contentItemAccessKey]",

    // SMART SHARE PUBLIC PAGES
    SMART_SHARE_AUTHOR_PAGE = "/[author]/o/[smartShareURL]",
    SMART_SHARE_ABOUT_PAGE = "/[author]/o/[smartShareURL]/p/[aboutPageSlug]",
    SMART_SHARE_PROFILE_COLLECTION_PAGE = "/[author]/o/[smartShareURL]/c/[collectionAccessKey]",
    SMART_SHARE_PROFILE_CONTENT_ITEM_PAGE = "/[author]/o/[smartShareURL]/a/[contentItemAccessKey]",
    SMART_SHARE_COLLECTION_PAGE = "/[author]/v/[smartShareURL]",
    SMART_SHARE_COLLECTION_CONTENT_ITEM_PAGE = "/[author]/v/[smartShareURL]/a/[contentItemAccessKey]",
    SMART_SHARE_CONTENT_ITEM_PAGE = "/[author]/i/[smartShareURL]",

    // UNAVAILABLE CONTENT
    UNAVAILABLE_CONTENT = "/content-unavailable",
    UNAVAILABLE_PROFILE = "/profile-unavailable",
    UNAVAILABLE_COLLECTION = "/collection-unavailable",
    UNAVAILABLE_CERTIFICATE = "/certificate-unavailable",

    // Signup / Auth routes
    SIGNUP = "/signup",
    SIGNUP_DEACTIVATED = "/signup/deactivated",
    SIGNUP_ACCOUNT = "/signup/account",
    SIGNUP_COMPLETE_NAME = "/signup/complete-name",
    SIGNUP_ANIMATION = "/signup/animation",
    SIGNUP_SUBSCRIPTION = "/signup/subscription",

    LOGIN = "/login",
    LOGIN_FORGOTTEN_PASSWORD = "/login/forgotten-password",
    OAUTH = "/login/oauth",
    OAUTH_APPROVE = "/oauth/approve",

    // Public static pages routes
    HOMEPAGE = "/",
    HOMEPAGE_VARIANT = "/home",

    //Features
    PORTFOLIO = "/features/portfolio",
    ARCHIVE = "/features/backup",
    ANALYTICS_MARKETING = "/features/analytics",
    TRACKING = "/features/tracking",
    COLLECTIONS_MARKETING = "/features/collections",
    NEWSLETTER_MARKETING = "/features/newsletter",

    // Customers
    USE_CASE_WRITERS = "/customers/writers",
    USE_CASE_THOUGHT_LEADERS = "/customers/thought-leaders",
    USE_CASE_CONTENT_MARKETERS = "/customers/content-marketers",
    USE_CASE_JOURNALISTS = "/customers/journalists",

    // Resources
    OWNERSHIP = "/resources/ownership",
    ABOUT = "/resources/about",
    PORTFOLIO_CREATOR = "/resources/portfolio-creator",
    PORTFOLIO_PAGE = "/resources/portfolio-page",
    PARTNERS = "/resources/partners",
    PARTNERS_TOS = "/resources/partners/tos",
    EXTENSION = "/resources/extension",

    IMPRINT = "/imprint",
    PRIVACY = "/privacy",
    TERMS = "/tos",
    DMCA = "https://authory.com/help/en/articles/4614822-copyright-policy",
    PRICING = "/pricing",

    // Ghost powered pages
    BLOG = "/blog",
    BLOG_AUTHOR = "/blog/author",
    BLOG_TAG = "/blog/tag",
    BLOG_POST = "/blog/[slug]",
    DIRECTORY = "/directory",
    TUTORIALS = "/resources/tutorials",

    // Programatic SEO
    EXAMPLES = "/examples",
    EXAMPLES_PROFESSION = "/examples/profession",
    EXAMPLES_CATEGORIES = "/examples/categories",
    EXAMPLES_PROFESSION_CATEGORIES = "/examples/professional-categories",
    EXAMPLES_JOB = "/examples/[job]",
    USE_CASES = "/use-cases",
    USE_CASES_PROFESSION = "/use-cases/profession",
    USE_CASES_PROFESSION_CATEGORIES = "/use-cases/professional-categories",
    USE_CASES_JOB = "/use-cases/[job]",
    USE_CASES_JOB_SEEKERS = "/use-cases/for-job-seekers",
    USE_CASES_JOB_WRITERS_LOOKING_FOR_WORK = "/use-cases/for-writers-looking-for-work",
    USE_CASES_PORTFOLIO_EXAMPLES = "/use-cases/portfolio-examples"
}
